/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { PaymentListResponse } from '../../models/payment-list-response';

export interface BookingControllerEarnedPayments$Params {
  query?: string;
  funding?: boolean;
  from_date?: string;
  to_date?: string;
  from_amount?: number;
  to_amount?: number;
  payment_method_id?: string;
  limit: number;
  skip: number;
}

export function bookingControllerEarnedPayments(http: HttpClient, rootUrl: string, params: BookingControllerEarnedPayments$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PaymentListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerEarnedPayments.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('funding', params.funding, {});
    rb.query('from_date', params.from_date, {});
    rb.query('to_date', params.to_date, {});
    rb.query('from_amount', params.from_amount, {});
    rb.query('to_amount', params.to_amount, {});
    rb.query('payment_method_id', params.payment_method_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: PaymentListResponse;
      }>;
    })
  );
}

bookingControllerEarnedPayments.PATH = '/booking/wallet/earned_payments';
